import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { bool, string } from 'prop-types';

import { ToastContext } from './context/ToastContext';
import { LoadingContext } from './context/LoadingContext';
import { buildProducts } from './ProductList';
import { Spinner } from 'react-bootstrap';
import '../styles/FilteredProductList.css';
import SearchPageProductListItem from './SearchPageProductListItem';

const DEFAULT_PAGE_LIMIT = 4;

function FilteredProductList({ title, subTitle, isFeatured, isBestSelling, isNew, isMobile }) {
    const [productList, setProductList] = useState([]);
    const { sendMessage } = useContext(ToastContext);
    const { startLoading, finishLoading } = useContext(LoadingContext);
    const [loading, setLoading] = useState(true);
    const productsData = useMemo(() => buildProducts(productList || []), [productList]);
    const fetchProducts = useCallback(async () => {
        try {
            setLoading(true);
            startLoading();
            const params = new URLSearchParams();
            params.append('page', 0);
            params.append('limit', DEFAULT_PAGE_LIMIT);
            if (isFeatured) {
                params.append('isFeatured', true);
            }
            if (isBestSelling) {
                params.append('sortBy', 'best_selling');
            }
            if (isNew) {
                params.append('sortBy', 'id_desc');
            }
            const response = await fetch(new URL(`/api/products/filter?${params.toString()}`, process.env.APP_URL));
            const data = await response.json();
            setProductList(data.products);
        } catch (e) {
            sendMessage(e.message, 'error');
        } finally {
            setLoading(false);
            finishLoading(false);
        }
    }, []);
    useEffect(() => {
        fetchProducts();
    }, [fetchProducts]);

    if (!productList?.length && !loading) {
        return null;
    }
    return (
        <div
            className={'filtered-products--container'}
        >
            <div
                className={'filtered-products--heading'}>
                <h2
                    className={'filtered-products--text'}>{title}</h2>
                {subTitle && <div
                    className={'mt-3'}>
                    <p
                        className={'text-muted'}>{subTitle}</p>
                </div>}
            </div>
            <div
                className={'filtered-products--wrapper'}
            >
                {loading ? <div
                    style={{
                        width: '100%',
                    }}
                    className={'d-flex justify-content-center align-items-center'}>
                    <Spinner></Spinner>
                </div> : null}
                {productList?.length ? productsData.map((product, i) => (
                    <SearchPageProductListItem
                        index={i}
                        key={product.id}
                        isMobile={isMobile}
                        title={product.title}
                        handle={product.handle}
                        imageUrl={product.imageUrl}
                        price={product.price}
                        compareAtPrice={product.compareAtPrice}
                        availableForSale={product.availableForSale}
                        avgRating={product.avgRating}
                        totalReviews={product.totalReviews}
                        collectionHandle={''}
                        isFeatured={product.isFeatured}
                        inventoryLevelId={product.inventoryLevelId}
                        availableQuantity={product.availableQuantity}
                        bypassNegativeQuantity={product.bypassNegativeQuantity}
                        view={'grid'}
                        searchLoading={false}
                    />
                )) : null}
            </div>
        </div>
    );
}

FilteredProductList.propTypes = {
    title: string,
    subTitle: string,
    isFeatured: bool,
    isBestSelling: bool,
    isNew: bool,
    isMobile: bool,
};

export default FilteredProductList;